<template>
  <div>
    <h2>第一个图层</h2>
    <h3>popover 层</h3>
    <demo>
      <vue-form :model="form" :layer="layer">
        <vue-form-line :cols="[{ span: 12, label: '商品名称', prop: '/form/name' }]">
          <el-input v-model="form.name" placeholder="请输入商品名称" />
        </vue-form-line>
      </vue-form>
      <div slot="description">
        <p>图层作用于 prop 指定的元素</p>
      </div>
      <div slot="meta">
        <vue-markdown v-highlight :source="content"></vue-markdown>
      </div>
    </demo>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: `
    <template>
      <vue-form :model="form" :layer="layer">
        <vue-form-line :cols="[{ span: 12, label: '商品名称', prop: '/form/name' }]">
          <el-input v-model="form.name" placeholder="请输入商品名称" />
        </vue-form-line>
      </vue-form>
    </template>

    <script>
    export default {
      data() {
        return {
          form: {
            name: ""
          },
          layer: [
            {
              data: [
                {
                  prop: "/form/name",
                  data: "商品名称必填"
                }
              ]
            }
          ]
        };
      }
    };
    <\/script>
      `,
      form: {
        name: ""
      },
      layer: [
        {
          data: [
            {
              prop: "/form/name",
              data: "商品名称必填"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/layer/frist.vue